<template>
  <header class='app-header'>
    <div class='menu-buttons'>
      <show-at breakpoint='small' v-if='!hideMenuToggle'>
        <img
          class='menu-icon toggle-button'
          @click='toggleMenu'
          src='~@/assets/ic-menu.svg'
        />
      </show-at>
      <router-link :to='{name: "authenticated"}' class='logo-container'>
        <img :src='logoUrl' alt='Home'>
      </router-link>
    </div>

    <div class='header-content'>
      <user-drop-menu></user-drop-menu>
      <div
        class='notification-button'
        ref='notificationButton'
        :class='{unread: Boolean(unread)}'
        @click='notificationButtonClicked'>
      </div>
    </div>

    <app-notifications
      :class='{opened: notificationsOpened}'
      :opened='notificationsOpened'
      ref='notificationsNode'>
    </app-notifications>
  </header>
</template>

<script>
  import { mapGetters } from 'vuex'
  import appNotifications from '@/components/app-notifications'
  import { showAt } from 'vue-breakpoints'
  import userDropMenu from '@/components/user-drop-menu'

  export default {
    name: 'app-header',
    data () {
      return {
        notificationsOpened: false,
        logoUrl: `/static/logo/${process.env.APP_ID}/logo-white.svg`
      }
    },

    components: {
      userDropMenu,
      appNotifications,
      showAt
    },

    computed: {
      ...mapGetters({
        unread: 'notifications/unread'
      }),
      hideMenuToggle () {
        return this.$route.meta.hideMenu
      }
    },

    mounted () {
      const listener = this._globalClickListener = ({ target }) => {
        const { notificationsNode, notificationButton } = this.$refs
        if (this.notificationsOpened &&
          !target.contains(notificationsNode.$el) &&
          target !== notificationsNode &&
          target !== notificationButton) {
          this.notificationsOpened = false
        }
      }

      self.addEventListener('click', listener)
    },

    destroyed () {
      const { _globalClickListener } = this
      if (_globalClickListener) {
        self.removeEventListener('click', _globalClickListener)
      }
    },

    methods: {
      notificationButtonClicked () {
        this.notificationsOpened = !this.notificationsOpened
      },
      toggleMenu () {
        this.$emit('toggleMenu')
      }
    }
  }
</script>

<style lang='scss' scoped rel='stylesheet/scss'>
  @import '~@/styles/vars.scss';

  .app-header {
    width: 100%;
    height: $header-height;
    background-color: $color-shark;
    color: white;
    padding: $space-medium;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 1.4rem;
    font-weight: 600;

    > .header-content {
      display: flex;
      align-items: center;
    }

    .menu-buttons {
      display: flex;
      align-items: center;

      .menu-icon {
        margin-right: $space-small;
        cursor: pointer;
      }
    }

    .logo-container {
      display: flex;
      align-items: center;

      img {
        height: 100%;
        width: auto;
      }
    }
  }

  .app-notifications {
    position: absolute;
    top: 7.5rem;
    right: 1.5rem;
    transition: opacity 300ms;
    opacity: 0;
    pointer-events: none;

    &.opened {
      pointer-events: auto;
      opacity: 1;
    }
  }

  .logo {
    font-size: 2.6rem;
    font-weight: 600;

    span {
      color: map_get($palette-primary, light);
    }
  }

  .notification-button {
    cursor: pointer;
    width: 1.6rem;
    height: 1.6rem;
    border-radius: 3px;
    border: 2px solid $color-silver;
    position: relative;
    margin-left: $space-big;

    &.unread:after {
      content: '';
      border-radius: 100%;
      background-color: map_get($palette-primary, light);
      height: 1rem;
      width: 1rem;
      border: 2px solid $color-raven;
      position: absolute;
      top: 0;
      right: 0;
      transform: translate(50%, -50%);
    }
  }
</style>
